export class RealEstateAgentModel {
  id?: string;
  name: string;
  title: string;
  phone: string;
  email: string;
  imageUrlFilePath?: string;
  imageUrl?: string;
}
